module.exports = __webpack_public_path__ + "img/docker-icon.94bb6b6d.svg";